import { ErrorOutline } from '@mui/icons-material';
import { ResourceProps } from 'react-admin';
import UnitErrorList from './UnitErrorList';
import UnitErrorShow from './UnitErrorShow';

const UnitErrorResource: ResourceProps = {
  name: 'dashboard/unit-errors',
  icon: ErrorOutline,
  list: UnitErrorList,
  show: UnitErrorShow,
  options: {
    label: 'Unit errors',
    isVisible: (hasPermission: Function) => hasPermission('view_dashboard'),
  },
};

export default UnitErrorResource;
